import { createRouter, createWebHashHistory, createWebHistory } from "vue-router";
import store from '@/store'
import Cookies from 'js-cookie'

export const constantRoutes = [
  /************  用户相关 ***********/
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/login.vue"),
    meta: {
      auth: false,
      title: "登录CMS系统",
      role: ['admin', 'agent', 'ess'],
    },
  },
  {
    path: "/regist",
    name: "regist",
    component: () => import("@/views/Register.vue"),
    meta: {
      auth: false,
      title: "注册新用户",
      role: ['admin', 'agent', 'ess'],
    },
  },
  {
    path: "/reset",
    name: "reset password",
    component: () => import("@/user/reset.vue"),
    meta: {
      auth: true,
      title: "修改用户密码",
      role: ['admin', 'agent', 'ess'],
    },
  },
  {
    path: "/db04",
    name: "UserSearch",
    component: () => import("@/user/userSearch.vue"),
    meta: {
      auth: true,
      title: "搜索用户",
      role: ['admin'],
    },
  },
  /************  任务相关 ***********/
  {
    path: "/todo",
    name: "todolist",
    component: () => import("@/todo/todoInstance.vue"),
    meta: {
      auth: true,
      title: "今日任务",
      role: ['admin', 'agent', 'ess'],
    },
  },
  {
    path: "/td01",
    name: "todorecordlist",
    component: () => import("@/todo/list/todoListInstance.vue"),
    meta: {
      auth: true,
      title: "管理今日任务",
      role: ['admin', 'agent', 'ess'],
    },
  },
  {
    path: "/td02",
    name: "todorecordcreate",
    component: () => import("@/todo/record/todoRecordCreate.vue"),
    meta: {
      auth: true,
      title: "创建今日任务",
      role: ['admin', 'agent', 'ess'],
    },
  },
  {
    path: "/td03/:id",
    name: "todorecordupdate",
    component: () => import("@/todo/record/todoRecordUpdate.vue"),
    meta: {
      auth: true,
      title: "创建今日任务",
      role: ['admin', 'agent', 'ess'],
    },
  },
  /************  数据管理相关 ***********/
  {
    path: "/db01/:dbName",
    name: "createDatadict",
    component: () => import("@/db/record/dbRecordCreate.vue"),
    meta: {
      auth: true,
      title: "配置管理",
      role: ['admin'],
    },
  },
  {
    path: "/db02/:dbName/:id",
    name: "updateDatadict",
    component: () => import("@/db/record/dbRecordUpdate.vue"),
    meta: {
      auth: true,
      title: "配置管理",
      role: ['admin'],
    },
  },
  {
    path: "/db03/:dbName",
    name: "DatadictQueue",
    component: () => import("@/db/list/dbListInstance.vue"),
    meta: {
      auth: true,
      title: "配置管理",
      role: ['admin'],
    },
  },
  {
    path: "/db06",
    name: "DatadictImport",
    component: () => import("@/db/record/dbImport.vue"),
    meta: {
      auth: true,
      title: "外部数据导入",
      role: ['admin'],
    },
  },
  /************  agent工单相关 ***********/
  {
    path: "/cs01",
    name: "createIncident",
    component: () => import("@/case/record/caseCreate.vue"),
    meta: {
      auth: true,
      title: "创建工单",
      role: ['admin', 'agent'],
    },
  },
  {
    path: "/cs02/:id",
    name: "updateIncident",
    component: () => import("@/case/record/caseUpdate.vue"),
    meta: {
      auth: true,
      title: "更新当前工单",
      role: ['admin', 'agent'],
    },
  },
  {
    path: "/cs03/:viewName",
    name: "incidentQueue",
    component: () => import("@/case/list/caseInstance.vue"),
    meta: {
      auth: true,
      title: "工单列表",
      role: ['admin', 'agent'],
    },
  },
  {
    path: "/cs04/:id",
    name: "closedIncident",
    component: () => import("@/case/record/caseClosed.vue"),
    meta: {
      auth: true,
      title: "关闭工单信息",
      role: ['admin', 'agent'],
    },
  },
  {
    path: "/cs05",
    name: "searchIncident",
    component: () => import("@/case/record/caseSearch.vue"),
    meta: {
      auth: true,
      title: "搜索工单信息",
      role: ['admin', 'agent'],
    },
  },
  /************  ess工单相关 ***********/
  {
    path: "/es01",
    name: "essCreate",
    component: () => import("@/ess/record/essRecordCreate.vue"),
    meta: {
      auth: true,
      title: "新建工单信息",
      role: ['ess'],
    },
  },
  {
    path: "/es02/:viewName",
    name: "essList",
    component: () => import("@/ess/list/essListInstance.vue"),
    meta: {
      auth: true,
      title: "新建工单信息",
      role: ['ess'],
    },
  },
  {
    path: "/es03/:id",
    name: "essUpdate",
    component: () => import("@/ess/record/essRecordUpdate.vue"),
    meta: {
      auth: true,
      title: "更新当前工单",
      role: ['ess'],
    },
  },
  {
    path: "/es04/:id",
    name: "essResolve",
    component: () => import("@/ess/record/essRecordResolved.vue"),
    meta: {
      auth: true,
      title: "当前工单解决方案提供",
      role: ['ess'],
    },
  },
  {
    path: "/es05/:id",
    name: "essClose",
    component: () => import("@/ess/record/essRecordClosed.vue"),
    meta: {
      auth: true,
      title: "当前关闭工单",
      role: ['ess'],
    },
  },
  /************  系统列表相关 ***********/
  {
    path: "/li01",
    name: "listManagement",
    component: () => import("@/studio/lister/listerInstance.vue"),
    meta: {
      auth: true,
      title: "列表管理",
      role: ['admin'],
    },
  },
  /************  table list相关 ***********/
  {
    path: "/lv01/:type/:id",
    name: "createListView",
    component: () => import("@/studio/qbe/qbeView.vue"),
    meta: {
      auth: true,
      title: "列表视图管理",
      role: ['admin'],
    },
  },
  {
    path: "/lv02",
    name: "displayListView",
    component: () => import("@/studio/qbe/qbeInstance.vue"),
    meta: {
      auth: true,
      title: "列表视图",
      role: ['admin'],
    },
  },
  /************  details format相关 ***********/
  {
    path: "/dv01/:type/:id",
    name: "createFormView",
    component: () => import("@/studio/detail/detailView.vue"),
    meta: {
      auth: true,
      title: "表单视图管理",
      role: ['admin'],
    },
  },
  {
    path: "/dv02",
    name: "displayFormView",
    component: () => import("@/studio/detail/detailInstance.vue"),
    meta: {
      auth: true,
      title: "表单视图",
      role: ['admin'],
    },
  },
  /************  report相关 ***********/
  {
    path: "/rp01/:id",
    name: "reportView",
    component: () => import("@/report/reportPreview.vue"),
    meta: {
      auth: true,
      title: "报表视图",
      role: ['admin', 'agent'],
    },
  },
  {
    path: "/rp03",
    name: "reportList",
    component: () => import("@/report/list/repListInstance.vue"),
    meta: {
      auth: true,
      title: "视图列表",
      role: ['admin', 'agent'],
    },
  },
  {
    path: "/rp04",
    name: "createUserReport",
    component: () => import("@/report/record/repRecordCreate.vue"),
    meta: {
      auth: true,
      title: "创建用户报表",
      role: ['admin','agent'],
    },
  },
  {
    path: "/rp05/:id",
    name: "updateUserReport",
    component: () => import("@/report/record/repRecordUpdate.vue"),
    meta: {
      auth: true,
      title: "更新用户报表",
      role: ['admin','agent'],
    },
  },
  {
    path: "/rp06/:id",
    name: "displayDetail",
    component: () => import("@/report/reportDetail.vue"),
    meta: {
      auth: true,
      title: "报表详细信息",
      role: ['admin','agent'],
    },
  },
  /************  configurationItem相关 ***********/
  {
    path: "/ci01",
    name: "configItemCreate",
    component: () => import("@/configItem/record/ciRecordCreate.vue"),
    meta: {
      auth: true,
      title: "配置管理",
      role: ['admin'],
    },
  },
  {
    path: "/ci02/:id",
    name: "configItemUpdate",
    component: () => import("@/configItem/record/ciRecordUpdate.vue"),
    meta: {
      auth: true,
      title: "配置管理",
      role: ['admin'],
    },
  },
  {
    path: "/ci03",
    name: "configItemQueue",
    component: () => import("@/configItem/list/ciListInstance.vue"),
    meta: {
      auth: true,
      title: "配置管理",
      role: ['admin'],
    },
  },
  {
    path: "/ci04",
    name: "searchDevice",
    component: () => import("@/configItem/record/ciRecordSearch.vue"),
    meta: {
      auth: true,
      title: "搜索设备信息",
      role: ['admin', 'agent'],
    },
  },
  /************  ruleset list相关 ***********/
  {
    path: "/rs02/:id",
    name: "updateRulesetView",
    component: () => import("@/studio/ruleset/ruleView.vue"),
    meta: {
      auth: true,
      title: "规则视图管理",
      role: ['admin'],
    },
  },
  {
    path: "/rs01",
    name: "RulesetListView",
    component: () => import("@/studio/ruleset/ruleInstance.vue"),
    meta: {
      auth: true,
      title: "列表视图",
      role: ['admin'],
    },
  },
  /************  用户角色页面 ***********/
  {
    path: "/ur01",
    name: "user role",
    component: () => import("@/user/role.vue"),
    meta: {
      auth: true,
      title: "用户角色管理",
      role: ['admin'],
    },
  },
  /************  用户通知模版 ***********/
  {
    path: "/nf01",
    name: "notification format",
    component: () => import("@/notify/notifyInstance.vue"),
    meta: {
      auth: true,
      title: "用户通知模版管理",
      role: ['admin'],
    },
  },
  {
    path: "/nf02/:type/:id",
    name: "notification create and update",
    component: () => import("@/notify/notifyView.vue"),
    meta: {
      auth: true,
      title: "用户通知模版创建更新",
      role: ['admin'],
    },
  },
  {
    path: "/nf03/:id",
    name: "notification previewe",
    component: () => import("@/notify/notifyPreView.vue"),
    meta: {
      auth: true,
      title: "用户通知模版预览",
      role: ['admin'],
    },
  },
  /************  缺省index页面 ***********/
  {
    path: "/",
    name: "main",
    component: () => import("@/views/index.vue"),
    meta: {
      auth: true,
      title: "工单管理中心",
      role: ['admin', 'agent', 'ess'],
    },
  },

  {
    path: "/profile",
    name: "profile",
    component: () => import("@/user/profile.vue"),
    meta: {
      auth: true,
      title: "个人信息",
      role: ['admin', 'agent', 'ess'],
    },
  },

  {
    path: "/mail",
    name: "mail",
    component: () => import("@/views/email.vue"),
    meta: {
      auth: true,
      title: "邮件通知配置",
      role: ['admin'],
    },
  },

   {
    path: "/custom",
    name: "custom",
    component: () => import("@/db/custom.vue"),
    meta: {
      auth: true,
      title: "客户自定义表配置",
      role: ['admin'],
    },
  },

   {
    path: "/sys",
    name: "sysConfig",
    component: () => import("@/views/system.vue"),
    meta: {
      auth: true,
      title: "系统配置信息",
      role: ['admin'],
    },
  },

  {
    path: "/help",
    name: "help",
    component: () => import("@/help/instance.vue"),
    meta: {
      auth: false,
      title: "系统帮助信息",
      role: ['admin', 'agent', 'ess'],
    },
  },

  /************  出错页面    *********/
  {
    path: "/404",
    name: "404",
    component: () => import("@/views/404.vue"),
    meta: {
      auth: false,
      title: "出错信息",
      role: ['admin', 'agent', 'ess'],
    },
  },
  {
    path: "/500",
    name: "500",
    component: () => import("@/views/500.vue"),
    meta: {
      auth: false,
      title: "出错信息",
      role: ['admin', 'agent', 'ess'],
    },
  },
];

const router = createRouter({
  history: createWebHistory(),
  //history: createWebHashHistory(),
  routes: constantRoutes,
});

router.beforeEach((to, from, next) => {
  let auth = to.meta.auth;
  let roles = to.meta.role;
  let token = Cookies.get("token");

  document.title = to.meta.title;

  if (auth) {
    if (!token) {
      window.sessionStorage.setItem("target", to.fullPath);
      next({ 
        path: "/login"
        });
      return
    }
    else {
      if (store.state.token === '') {
        store.commit("getInfo")
        next()
      }
      else {
        if (roles.includes(store.state.user.group)) {
          next()
        } else {
          next({ path: "/404" });
        }
      }
    }
  }
  else {
    next();
  }
});

export default router;
